"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCtxBody = generateCtxBody;
const dates_1 = require("../dates");
/**
 * Generates the Markdown body for a context summary (ctx) document.
 * @param data - The summary data to include in the body.
 * @returns The complete Markdown body (excluding frontmatter).
 */
function generateCtxBody(data) {
    const decisions = data.decisions.map(d => `- ${d}`).join('\n');
    const questions = data.questions.map(q => `- ${q}`).join('\n');
    const plans = data.plans.map(p => `- ${p.id} (status: ${p.status}, progress: ${p.progress})`).join('\n');
    const now = (0, dates_1.nowIso)();
    return `
## Problem Statement
${data.goal}

## Context
${data.context}

## Key Decisions Made
${decisions}

## Open Questions
${questions}

## Active Plans
${plans}

---
*Generated: ${now}*
`;
}
